import environment from '../services/environment';

const globalStyles = !environment.isLocal
  ? {
      global: {
        ':where(img, video)': {
          maxWidth: 'unset',
          height: 'unset'
        },
        ':where(img, svg, video, canvas, audio, iframe, embed, object)': {
          display: 'unset'
        }
      }
    }
  : {
      global: {
        'html, body': {
          fontSize: '10px'
        }
      }
    };

const styles = {
  global: {
    ...globalStyles.global,
    'div, p': {
      fontSize: '1.6rem'
    }
  }
};

const sizes = {
  max: 'max-content',
  min: 'min-content',
  full: '100%',
  '3xs': '8.75rem',
  '2xs': '10rem',
  xs: '12.5rem',
  sm: '15rem',
  md: '17.5rem',
  lg: '20rem',
  xl: '22.5rem',
  '2xl': '26.25rem',
  '3xl': '30rem',
  '4xl': '35rem',
  '5xl': '40rem',
  '6xl': '45rem',
  '7xl': '50rem',
  '8xl': '56.25rem',
  container: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  }
};

const fonts = {
  body: 'DINNextLTProLight',
  heading: 'DINNextLTProLight',
  mono: 'DINNextLTProRLight'
};

const fontSizes = {
  xs: '1.2rem',
  sm: '1.4rem',
  md: '1.6rem',
  lg: '1.8rem',
  xl: '2rem',
  '2xl': '2.4rem',
  '3xl': '3rem',
  '4xl': '3.6rem',
  '5xl': '4.8rem',
  '6xl': '6rem',
  '7xl': '7.2rem',
  '8xl': '9.6rem',
  '9xl': '12.8rem'
};

const lineHeights = {
  normal: 'normal',
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: '2',
  '3': '1.2rem',
  '4': '1.6rem',
  '5': '2rem',
  '6': '2.4rem',
  '7': '2.8rem',
  '8': '3.2rem',
  '9': '3.6rem',
  '10': '4rem'
};

const spacing = {
  space: {
    px: '1px',
    0.5: '0.2rem',
    1: '0.4rem',
    1.5: '0.6rem',
    2: '0.8rem',
    2.5: '1rem',
    3: '1.2rem',
    3.5: '1.4rem',
    4: '1.6rem',
    5: '2rem',
    6: '2.4rem',
    7: '2.8rem',
    8: '3.2rem',
    9: '3.6rem',
    10: '4rem',
    12: '4.8rem',
    14: '5.6rem',
    16: '6.4rem',
    20: '8rem',
    24: '9.6rem',
    28: '11.2rem',
    32: '12.8rem',
    36: '14.4rem',
    40: '16rem',
    44: '17.6rem',
    48: '19.2rem',
    52: '20.8rem',
    56: '22.4rem',
    60: '24rem',
    64: '25.6rem',
    72: '28.8rem',
    80: '32rem',
    96: '38.4rem'
  }
};

const colors = {
  blue: {
    DEFAULT: '#00325D',
    50: '#cbd8e3', // lightest
    100: '#6577C3',
    200: '#515FB2',
    300: '#3D47A1',
    400: '#29308F',
    500: '#00325D', // base
    600: '#041558',
    700: '#031141',
    800: '#020D2A',
    900: '#010713' // darkest
  },
  orange: {
    DEFAULT: '#FF5E3A',
    50: '#FFEBE5',
    100: '#FFCAB8',
    200: '#FFA88B',
    300: '#FF865E',
    400: '#FF6431',
    500: '#FF5E3A', // base
    600: '#CC4A2F',
    700: '#993624',
    800: '#662219',
    900: '#33110F'
  },
  green: {
    DEFAULT: '#0F916C',
    50: '#E2F4F0', // lightest
    100: '#B3E3D8',
    200: '#81D1BF',
    300: '#4FBFA6',
    400: '#28AD91',
    500: '#0F916C', // base
    600: '#0C7557',
    700: '#095942',
    800: '#063D2D',
    900: '#031F17' // darkest
  }
};

export { sizes, fonts, fontSizes, lineHeights, spacing, colors, styles };
